import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import idx from 'idx';
import partial from 'lodash/partial';
import { update, fetch, fetchParticipants, fetchRevisions } from 'presentations/ducks';
import Presentation from 'presentations/components/presentation';

const mapStateToProps = (state) => {
  return {
    presentation: state.project.presentations.currentPresentation,
    participants: idx(state, _ => _.project.presentations.currentParticipants) || [],
    revisions: idx(state, _ => _.project.presentations.currentRevisions) || []
  };
}

const mapDispatchToProps = (dispatch, { params }) => {
  const { presentationId } = params;

  return bindActionCreators({
    fetch: partial(fetch, presentationId),
    update: partial(update, presentationId),
    fetchParticipants: partial(fetchParticipants, presentationId),
    fetchRevisions: partial(fetchRevisions, presentationId)
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Presentation);



// WEBPACK FOOTER //
// ./presentations/containers/presentation.js